import {AbstractAdvanceFilter} from './abstract-advance-filter';

export class CheckboxAdvanceFilter extends AbstractAdvanceFilter {

    public getValueFromChange(event, param) {
        return event;
    }
}
